export default function Spinner() {
  return <img className='animate-sweetch-load' src='/assets/loader.svg' />;
}
